import PropTypes from 'prop-types';

/* eslint-disable camelcase */
export const SLICE_PROP_TYPES = {
    slice_type: PropTypes.string.isRequired,
    primary: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
};
